import {Component, ViewChild, ViewContainerRef} from '@angular/core';
import {TableComponent} from "../../../shared/components/table/table.component";
import {GeneralService} from "../../../core/services/general.service";
import {CanceledEventListComponent} from "./canceled-event-list/canceled-event-list.component";
import {NgClass} from "@angular/common";
import {EventsTableComponent} from "./events-table/events-table.component";


@Component({
  selector: 'app-event',
  standalone: true,
  imports: [
    TableComponent,
    NgClass
  ],
  templateUrl: './event.component.html',
  styleUrl: './event.component.scss'
})
export class EventComponent {
  public tab: string = 'service-events';

  @ViewChild('containerCanceledEvents', { read: ViewContainerRef }) containerCanceled!: ViewContainerRef;
  @ViewChild('containerActiveEvents', { read: ViewContainerRef }) containerActive!: ViewContainerRef;
  constructor(private generalService:GeneralService) {}

  changeTab(value: string) {
    this.tab = value;
    if(value == "canceled-events") {
      this.containerCanceled.clear(); // Opcional: limpia antes de insertar
      this.containerCanceled.createComponent(CanceledEventListComponent);
    } else if(value == "service-events") {
      this.loadActiveEvents();
    }
  }

  ngAfterViewInit() {
    this.loadActiveEvents();
  }

  loadActiveEvents() {
    this.containerActive.clear(); // Opcional: limpia antes de insertar
    this.containerActive.createComponent(EventsTableComponent);

  }
}
